import { render } from "./TableMain.vue?vue&type=template&id=2257af17"
import script from "./TableMain.vue?vue&type=script&lang=js"
export * from "./TableMain.vue?vue&type=script&lang=js"

import "./TableMain.vue?vue&type=style&index=0&id=2257af17&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__